import { useState } from "react";
import { Search, CheckCircle2 } from "lucide-react";
import { TRACKING_STEPS } from "../../data/content";

export const Tracking = () => {
  const [orderId, setOrderId] = useState("");
  const [active, setActive] = useState(2); // mock: order is currently "packed"

  const handleTrack = () => {
    if (orderId.trim().length > 0) {
      setActive(3);
    }
  };

  return (
    <section id="tracking" className="py-24 md:py-32 bg-white border-t border-neutral-200" data-testid="tracking-section">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Heading + input */}
          <div className="md:col-span-5">
            <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-4 font-medium">
              Order tracking
            </div>
            <h2 className="font-heading leading-[0.95] tracking-tight">
              <span className="block text-4xl md:text-6xl font-black">Know exactly</span>
              <span className="block text-4xl md:text-6xl font-thin">where it is.</span>
            </h2>
            <p className="mt-6 text-neutral-600 font-light max-w-md">
              Enter your order ID to see real-time cold-chain status from our warehouse to your clinic.
            </p>

            <div className="mt-8 flex border border-neutral-300 bg-white max-w-md">
              <input
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                placeholder="Order ID · e.g. DF-58291"
                className="flex-1 px-5 py-4 text-sm bg-transparent focus:outline-none placeholder:text-neutral-400"
                data-testid="tracking-input"
              />
              <button
                onClick={handleTrack}
                className="bg-black text-white px-5 hover:bg-neutral-800 transition-colors flex items-center gap-2"
                data-testid="tracking-submit"
              >
                <Search className="w-4 h-4" />
                <span className="text-sm font-medium">Track</span>
              </button>
            </div>
          </div>

          {/* Timeline */}
          <div className="md:col-span-7 md:col-start-6">
            <div className="bg-neutral-50 border border-neutral-200 p-8 md:p-10">
              <div className="flex items-center justify-between mb-8 pb-6 border-b border-neutral-200">
                <div>
                  <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 font-medium">Order</div>
                  <div className="font-heading text-2xl font-black tracking-tight">DF-58291</div>
                </div>
                <div className="text-right">
                  <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 font-medium">ETA</div>
                  <div className="font-heading text-xl font-thin">3 days</div>
                </div>
              </div>
              <ol className="space-y-5">
                {TRACKING_STEPS.map((s, i) => {
                  const done = i <= active;
                  const current = i === active;
                  return (
                    <li key={s.code} className="flex items-center gap-5" data-testid={`track-step-${s.code}`}>
                      <div
                        className={`w-10 h-10 flex items-center justify-center border ${
                          done ? "bg-black border-black text-white" : "bg-white border-neutral-300 text-neutral-400"
                        }`}
                      >
                        {done ? <CheckCircle2 className="w-4 h-4" /> : <span className="text-xs font-bold">{s.code}</span>}
                      </div>
                      <div className="flex-1 flex items-center justify-between gap-4">
                        <div>
                          <div className={`font-heading text-base font-bold ${done ? "text-black" : "text-neutral-400"}`}>
                            {s.label}
                          </div>
                          <div className="text-xs text-neutral-500 font-light">{s.time}</div>
                        </div>
                        {current && (
                          <span className="text-[10px] tracking-[0.2em] uppercase bg-black text-white px-3 py-1 font-medium">
                            Now
                          </span>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
